module.exports = __webpack_public_path__ + "img/21.6f7895ad.jpg";